import {
  ErrorPage as AUIErrorPage,
  type ErrorPageProps,
} from '@soluto-private/mx-asurion-ui-react';

import { useInViewAnalytics } from '@service-initiation/shared-data-access-analytics';

export const ErrorPage: React.FC<ErrorPageProps> = (props) => {
  const { ref } = useInViewAnalytics('ErrorPage');

  return (
    <div ref={ref}>
      <AUIErrorPage {...props} />
    </div>
  );
};
